var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-content my-events-page" }, [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "my-events-page-header" },
          [
            _c("icon", { attrs: { name: "icon-wifi" } }),
            _vm._v(" "),
            _c("h1", [_vm._v(_vm._s(_vm.$t("Favorites.MyEvents")))]),
            _vm._v(" "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.goToEventSettings()
                  }
                }
              },
              [_c("icon", { attrs: { name: "icon-acc-settings" } })],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        [
          _c(
            "div",
            { staticClass: "my-events-page-content marketgroup" },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "favorite-tabs",
                  attrs: { "fixed-tabs": "", "align-with-title": "" }
                },
                [
                  _vm.favTabs && _vm.favTabs.length > 1
                    ? _c(
                        "v-tab",
                        {
                          class: { active: _vm.selectedTab === "all" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectTab("all")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Favorites.MyEvents.Tabs.All")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.favTabs && _vm.favTabs.includes("PlayerFavorites")
                    ? _c(
                        "v-tab",
                        {
                          class: {
                            active: _vm.selectedTab === "playerFavorites"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectTab("playerFavorites")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Favorites.MyEvents.Tabs.Favorites"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.favTabs && _vm.favTabs.includes("FrequentlyPlayed")
                    ? _c(
                        "v-tab",
                        {
                          class: {
                            active: _vm.selectedTab === "frequentlyPlayed"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.selectTab("frequentlyPlayed")
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Favorites.MyEvents.Tabs.FrequentlyPlayed")
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.favEventsLoaded
                ? [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("dots-loader")],
                      1
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.favEventsLoaded
                ? [
                    !_vm.favEventsProcessed ||
                    _vm.favEventsProcessed.length === 0
                      ? _c("div", { staticClass: "events" }, [
                          _c("div", { staticClass: "no_events" }, [
                            _c("h1", [
                              _vm._v(
                                _vm._s(_vm.$t("Favorites.MyEvents.NoEvents"))
                              )
                            ])
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.favEventsProcessed && _vm.favEventsProcessed.length > 0
                      ? _c(
                          "div",
                          { staticClass: "events" },
                          _vm._l(_vm.availableSportTypes, function(
                            item,
                            $index
                          ) {
                            return _c(
                              "div",
                              { key: $index },
                              [
                                _c("big3-markets-header", {
                                  attrs: {
                                    coupontitle: item,
                                    idfosporttype: item,
                                    "is-big3-coupon": _vm.isBig3Coupon(
                                      _vm.favEventsProcessed.filter(function(
                                        ev
                                      ) {
                                        return ev.idfosporttype === item
                                      })
                                    ),
                                    "has-draw": _vm.hasDraw(
                                      _vm.favEventsProcessed.filter(function(
                                        ev
                                      ) {
                                        return ev.idfosporttype === item
                                      })
                                    ),
                                    "max-no-of-markets": _vm.maxNumberOfMarkets(
                                      _vm.favEventsProcessed.filter(function(
                                        ev
                                      ) {
                                        return ev.idfosporttype === item
                                      })
                                    ),
                                    "max-no-of-selections": _vm.maxNumberOfSelections(
                                      _vm.favEventsProcessed.filter(function(
                                        ev
                                      ) {
                                        return ev.idfosporttype === item
                                      })
                                    ),
                                    isoutright: false
                                  }
                                }),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.favEventsProcessed.filter(function(ev) {
                                    return ev.idfosporttype === item
                                  }),
                                  function(event, $index) {
                                    return _c(
                                      "div",
                                      {
                                        key: $index,
                                        class: [
                                          "event",
                                          {
                                            last:
                                              $index ===
                                              _vm.favEventsProcessed.filter(
                                                function(ev) {
                                                  return (
                                                    ev.idfosporttype === item
                                                  )
                                                }
                                              ).length -
                                                1
                                          },
                                          { first: $index === 0 },
                                          {
                                            "big-three-one-selection-per-event":
                                              _vm.isBig3Coupon(
                                                _vm.favEventsProcessed.filter(
                                                  function(ev) {
                                                    return (
                                                      ev.idfosporttype === item
                                                    )
                                                  }
                                                )
                                              ) &&
                                              _vm.maxNumberOfMarkets(
                                                _vm.favEventsProcessed.filter(
                                                  function(ev) {
                                                    return (
                                                      ev.idfosporttype === item
                                                    )
                                                  }
                                                )
                                              ) === 1
                                          }
                                        ]
                                      },
                                      [
                                        event.liveEvent
                                          ? [
                                              _c(
                                                "v-flex",
                                                { staticClass: "wrapper" },
                                                [
                                                  _c("live-event-info", {
                                                    attrs: {
                                                      event: _vm.liveEvents.find(
                                                        function(liveEvent) {
                                                          return (
                                                            liveEvent.idfoevent ===
                                                            event.idfoevent
                                                          )
                                                        }
                                                      ),
                                                      page: "coupon",
                                                      couponname: item
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  event.markets
                                                    ? _c("markets", {
                                                        attrs: {
                                                          markets:
                                                            event.markets,
                                                          event: event,
                                                          maxnumofmarkets: "3",
                                                          iscoupondisplay: true,
                                                          pricechangehighlight: true,
                                                          diplayOnPage:
                                                            "marketGroup",
                                                          couponname: item
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  !event.markets
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "nomarkets"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "Sports.NoAvailableMarkets"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("live-coupon-event-footer", {
                                                attrs: {
                                                  event: event.liveEvent
                                                }
                                              })
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        !event.liveEvent
                                          ? [
                                              event.idfosporttype === item
                                                ? _c("coupon-event", {
                                                    attrs: {
                                                      event: event,
                                                      twoselections:
                                                        !_vm.isBig3Coupon(
                                                          _vm.favEventsProcessed.filter(
                                                            function(ev) {
                                                              return (
                                                                ev.idfosporttype ===
                                                                item
                                                              )
                                                            }
                                                          )
                                                        ) &&
                                                        !_vm.hasDraw(
                                                          _vm.favEventsProcessed.filter(
                                                            function(ev) {
                                                              return (
                                                                ev.idfosporttype ===
                                                                item
                                                              )
                                                            }
                                                          )
                                                        ),
                                                      threeselections:
                                                        !_vm.isBig3Coupon(
                                                          _vm.favEventsProcessed.filter(
                                                            function(ev) {
                                                              return (
                                                                ev.idfosporttype ===
                                                                item
                                                              )
                                                            }
                                                          )
                                                        ) &&
                                                        _vm.hasDraw(
                                                          _vm.favEventsProcessed.filter(
                                                            function(ev) {
                                                              return (
                                                                ev.idfosporttype ===
                                                                item
                                                              )
                                                            }
                                                          )
                                                        ),
                                                      isbig3coupon: _vm.isBig3Coupon(
                                                        _vm.favEventsProcessed.filter(
                                                          function(ev) {
                                                            return (
                                                              ev.idfosporttype ===
                                                              item
                                                            )
                                                          }
                                                        )
                                                      ),
                                                      couponname: _vm.favEventsProcessed.filter(
                                                        function(ev) {
                                                          return (
                                                            ev.idfosporttype ===
                                                            item
                                                          )
                                                        }
                                                      )[0].fosporttypename
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  }
                                )
                              ],
                              2
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                : _vm._e()
            ],
            2
          )
        ]
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f9af1d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9af1d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/MyEvents.vue
// module id = null
// module chunks = 